(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wtc-help-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__wtcHelpInit) return; window.__wtcHelpInit = true;

  function closeAll(scope){ (scope||document).querySelectorAll('.hc-card').forEach(function(c){ c.classList.remove('is-open'); var h=c.querySelector('.hc-card-head'); if(h) h.setAttribute('aria-expanded','false'); }); }

  document.addEventListener('click', function(e){
    var head = e.target.closest && e.target.closest('.hc-card-head');
    if (head){
      var card = head.closest('.hc-card');
      var open = card.classList.contains('is-open');
      var grid = card.closest('.hc-grid, .hc-membership-card') || document;
      grid.querySelectorAll('.hc-card').forEach(function(c){ c.classList.remove('is-open'); var h=c.querySelector('.hc-card-head'); if(h) h.setAttribute('aria-expanded','false'); });
      if(!open){ card.classList.add('is-open'); head.setAttribute('aria-expanded','true'); }
      return;
    }
    var q = e.target.closest && e.target.closest('.hc-q');
    if (q){
      var ans = q.nextElementSibling;
      if(!ans || !ans.classList.contains('hc-a')) return;
      var c = q.closest('.hc-card');
      var isOpen = ans.classList.contains('is-open');
      c.querySelectorAll('.hc-a').forEach(function(a){ a.classList.remove('is-open'); });
      c.querySelectorAll('.hc-q').forEach(function(qq){ qq.classList.remove('is-open'); qq.setAttribute('aria-expanded','false'); });
      if(!isOpen){ ans.classList.add('is-open'); q.classList.add('is-open'); q.setAttribute('aria-expanded','true'); }
      return;
    }
    var pill = e.target.closest && e.target.closest('.hc-quick a');
    if (pill){
      var hash = pill.getAttribute('href');
      if(!hash || hash.indexOf('#')!==0) return;
      var target = document.querySelector(hash);
      if(!target) return;
      e.preventDefault();
      closeAll();
      target.classList.add('is-open');
      target.scrollIntoView({behavior:'smooth', block:'start'});
    }
  });

  function escapeHtml(s){ return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
  function escapeRegex(s){ return s.replace(/[.*+?^${}()|[\]\\]/g,'\\$&'); }
  function highlight(t,q){ if(!q) return escapeHtml(t); var re=new RegExp('('+escapeRegex(q)+')','gi'); return escapeHtml(t).replace(re,'<mark class="hc-mark">$1</mark>'); }
  function cacheQ(){ document.querySelectorAll('.hc-q').forEach(function(qb){ var sp=qb.querySelector('span:not(.hc-q-icon)'); if(sp && !sp.dataset.originalText) sp.dataset.originalText=sp.textContent; }); }

  function performSearch(query){
    query=(query||'').trim().toLowerCase();
    var any=false;
    document.querySelectorAll('.hc-card').forEach(function(card){
      var matched=false;
      card.querySelectorAll('.hc-q').forEach(function(qb){
        var sp=qb.querySelector('span:not(.hc-q-icon)');
        var orig=sp?sp.dataset.originalText:qb.textContent;
        var qt=(orig||'').toLowerCase();
        var aEl=qb.nextElementSibling;
        var at=aEl?aEl.textContent.toLowerCase():'';
        if(!query){ if(sp)sp.textContent=orig; qb.style.display=''; qb.classList.remove('is-open'); if(aEl)aEl.classList.remove('is-open'); return; }
        var inQ=qt.indexOf(query)!==-1, inA=at.indexOf(query)!==-1;
        if(inQ||inA){ matched=true; qb.style.display=''; if(sp&&inQ){sp.innerHTML=highlight(orig,query);} else if(sp){sp.textContent=orig;} if(!inQ&&inA){qb.classList.add('is-open'); if(aEl)aEl.classList.add('is-open');} }
        else { qb.style.display='none'; qb.classList.remove('is-open'); if(aEl)aEl.classList.remove('is-open'); if(sp)sp.textContent=orig; }
      });
      if(!query){ card.classList.remove('is-open','hc-card--no-match'); }
      else if(matched){ card.classList.add('is-open'); card.classList.remove('hc-card--no-match'); any=true; }
      else { card.classList.remove('is-open'); card.classList.add('hc-card--no-match'); }
    });
    var banner=document.querySelector('.hc-search-empty');
    if(query && !any){
      if(!banner){ banner=document.createElement('div'); banner.className='hc-search-empty'; banner.innerHTML='<p>No matches for &ldquo;<span class="hc-search-empty-q"></span>&rdquo;. Try a different keyword, or browse a topic below.</p>'; var topics=document.querySelector('.hc-topics'); if(topics) topics.insertBefore(banner, topics.firstChild); }
      if(banner){ var qq=banner.querySelector('.hc-search-empty-q'); if(qq) qq.textContent=query; banner.style.display=''; }
    } else if(banner){ banner.style.display='none'; }
    document.querySelectorAll('.hc-q').forEach(function(qq){ qq.setAttribute('aria-expanded', qq.classList.contains('is-open')?'true':'false'); });
    document.querySelectorAll('.hc-card').forEach(function(cc){ var h=cc.querySelector('.hc-card-head'); if(h) h.setAttribute('aria-expanded', cc.classList.contains('is-open')?'true':'false'); });
  }

  var timer;
  document.addEventListener('input', function(e){
    if(!e.target.classList || !e.target.classList.contains('hc-search-input')) return;
    cacheQ(); clearTimeout(timer); var v=e.target.value; timer=setTimeout(function(){ performSearch(v); },80);
  });
  document.addEventListener('keydown', function(e){
    if(e.target.classList && e.target.classList.contains('hc-search-input') && e.key==='Escape'){ e.target.value=''; performSearch(''); }
  });
  document.querySelectorAll('.hc-search').forEach(function(f){ if(f.tagName==='FORM') f.addEventListener('submit', function(ev){ ev.preventDefault(); }); });
  cacheQ();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wtc-sf-howitworks"] && !Shopify.designMode) return;
  try {
    
  (function(){
    if (window.__wtcHiwVid) return; window.__wtcHiwVid = true;
    function setup(){
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var wraps = document.querySelectorAll('.hiw-img');
      for (var i = 0; i < wraps.length; i++) {
        var vid = wraps[i].querySelector('video');
        var btn = wraps[i].querySelector('.hiw-vid-toggle');
        if (!vid || !btn || btn.dataset.bound) continue;
        btn.dataset.bound = '1';
        if (reduce) { try { vid.pause(); vid.removeAttribute('autoplay'); } catch (e) {} }
        (function(vid, btn){
          function sync(){
            var playing = !vid.paused;
            btn.dataset.state = playing ? 'playing' : 'paused';
            btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
          }
          btn.addEventListener('click', function(){ if (vid.paused) { vid.play(); } else { vid.pause(); } });
          vid.addEventListener('play', sync);
          vid.addEventListener('pause', sync);
          sync();
        })(vid, btn);
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
    document.addEventListener('shopify:section:load', setup);
  })();

  } catch(e) { console.error(e); }
})();
})();
